<script setup lang="ts">
import { FeaturedTile, HtmlHeadings } from '~/lib/services/content/content.blocks.dtos'

defineProps<{
  block: FeaturedTile
}>()

const isMobile = inject('isMobile')
</script>

<template>
  <section
    :class="block.imagePosition === 'right' ? 'lg:flex-row-reverse' : 'lg:flex-row'"
    class="lg:h-max-[492px] mt-20 flex w-full flex-col"
  >
    <figure class="lg:w-[39%]">
      <img
        :src="isMobile ? block.imageMobile.url : block.imageDesktop.url"
        class="h-full w-full object-cover"
        :alt="
          (isMobile ? block.imageMobile.alternativeText : block.imageDesktop.alternativeText) ||
          undefined
        "
      />
    </figure>

    <aside class="flex flex-col gap-8 p-8 lg:w-[61%] lg:px-[104px] lg:py-14">
      <header class="flex h-full flex-col justify-center gap-4">
        <RenderTitleAs
          class="text-[32px] font-bold leading-9 tracking-[-0.15px] lg:text-5xl lg:leading-[54px]"
          :text="block.title"
          :render-as="block.titleRenderAs || HtmlHeadings.H2"
        />
        <p class="text-sm leading-4 tracking-[-0.15px] lg:text-lg">{{ block.content }}</p>
      </header>

      <section class="flex flex-col gap-4">
        <p class="text-2xl font-bold tracking-[-0.15px] lg:text-[32px] lg:leading-9">
          {{ block.bulletPoints?.title }}
        </p>

        <ul>
          <li v-for="bullet in block.bulletPoints?.bulletPointsList" :key="bullet.id">
            <figure class="flex items-center gap-2">
              <img src="/images/icons/commons/checkmark.svg" alt="checkMark" />
              <h4 class="line-clamp-1 text-lg leading-6 tracking-[-0.15px]">
                {{ bullet.content }}
              </h4>
            </figure>
          </li>
        </ul>
      </section>
    </aside>
  </section>
</template>
